import React from "react";
import { NavTab } from "./LectureHeader";

interface LectureBottomNavProps {
  navTabs: NavTab[];
  activeTab: string;
  setActiveTab: (id: string) => void;
}

const LectureBottomNav: React.FC<LectureBottomNavProps> = ({
  navTabs,
  activeTab,
  setActiveTab,
}) => {
  return (
    <div
      className="mobile-bottom-nav"
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        height: "64px",
        backgroundColor: "#ffffff",
        borderTop: "1px solid #f0f0f0",
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        zIndex: 1000,
        padding: "0 8px",
        boxShadow: "0 -2px 10px rgba(0, 0, 0, 0.05)",
      }}
    >
      {navTabs.map((tab) => {
        const isActive = activeTab === tab.id;
        return (
          <div
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "3px",
              cursor: "pointer",
              color: isActive ? "var(--primary-text)" : "#9ca3af",
              fontSize: "10px",
              fontWeight: isActive ? 700 : 500,
              userSelect: "none",
            }}
          >
            <div
              style={{
                width: "32px",
                height: "32px",
                borderRadius: "50%",
                backgroundColor: isActive
                  ? "var(--primary-text)"
                  : "transparent",
                color: isActive ? "#ffffff" : "#9ca3af",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "16px",
                transition: "all 0.2s ease-in-out",
              }}
            >
              {tab.icon}
            </div>
            <span>{tab.label}</span>
          </div>
        );
      })}
    </div>
  );
};

export default LectureBottomNav;
